<template>
  <div class="wrapper black">
    <div class="section unlock-page-header" :style="backgroundStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 text-center">
            <h2 class="title-white">{{ title }}</h2>
          </div>
          <div
            class="md-layout-item md-size-25 md-small-size-100 margin-top-32"
            :class="{ 'mx-auto': !isMobileDevice }"
          >
            <p v-if="error" class="alert">Wrong password!</p>
            <input
              placeholder="Password"
              onfocus="this.placeholder = ''"
              onblur="this.placeholder = 'Password'"
              v-model="password"
              @keyup.enter="processForm"
            />
            <div @click="processForm">
              <img
                class="arrow"
                :style="inputHasValue ? { opacity: '1' } : { opacity: '0.4' }"
                :src="arrow"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "protected",
  bodyClass: "protected-page",
  props: {
    arrow: {
      type: String,
      default: require("@/assets/img/protected/arrow.png")
    },
    avatar: {
      type: String,
      default: require("@/assets/img/protected/avatar.png")
    },
    concert: {
      type: String,
      default: require("@/assets/img/protected/concert.png")
    },
    discovery: {
      type: String,
      default: require("@/assets/img/protected/discovery.png")
    },
    sfdw: {
      type: String,
      default: require("@/assets/img/protected/sfdw.png")
    },
    system: {
      type: String,
      default: require("@/assets/img/protected/system.png")
    },
    yoyolumi: {
      type: String,
      default: require("@/assets/img/protected/yoyolumi.png")
    }
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${this.backgroundUrl})`,
        backgroundSize: `cover`
      };
    }
  },
  data() {
    return {
      password: null,
      error: false,
      isMobileDevice: this.$isMobile,
      backgroundUrl: "",
      title: "",
      inputHasValue: false
    };
  },
  methods: {
    processForm() {
      var md5 = require("md5");
      if (this.password == null) {
        this.error = true;
      } else if (md5(this.password) === "819e3d6c1381eac87c17617e5165f38c") {
        window.localStorage.setItem(
          "password",
          "819e3d6c1381eac87c17617e5165f38c"
        );
        router.push({ name: this.$route.query.previousRouter });
        this.error = false;
      } else {
        this.error = true;
      }
    }
  },
  watch: {
    $route: {
      handler: function() {
        let router = this.$route.query.previousRouter;
        if (router === "avatar") {
          this.backgroundUrl = this.avatar;
          this.title = this.$t("avatar.header_title");
        } else if (router === "concert") {
          this.backgroundUrl = this.concert;
          this.title = this.$t("concert.header_title");
        } else if (router === "discovery") {
          this.backgroundUrl = this.discovery;
          this.title = this.$t("discovery.header_title");
        } else if (router === "sfdw") {
          this.backgroundUrl = this.sfdw;
          this.title = this.$t("sfdw.header_title");
        } else if (router === "system") {
          this.backgroundUrl = this.system;
          this.title = this.$t("system.header_title");
        } else if (router === "yoyolumi") {
          this.backgroundUrl = this.yoyolumi;
          this.title = this.$t("yoyolumi.header_title");
        }
      },
      deep: true,
      immediate: true
    },
    password: function(val) {
      if (val.length != 0) {
        this.inputHasValue = true;
      } else {
        this.inputHasValue = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.login-padding {
  padding-bottom: 50% !important;
}
.login-button {
  font-size: 1rem;
  line-height: 1.333333;
  padding: 0;
  border: none;
  background: none;
  height: 50%;
  &,
  &:hover,
  &:focus,
  &:active,
  &.active,
  &:active:focus,
  &:active:hover,
  &.active:focus,
  &.active:hover,
  .open > &.dropdown-toggle,
  .open > &.dropdown-toggle:focus,
  .open > &.dropdown-toggle:hover {
    background-color: transparent !important;
    color: #388e3c !important;
    box-shadow: none;

    i {
      color: #388e3c !important;
    }
  }
}
.alert {
  color: #c50e08 !important;
  font-size: 1.2rem;
  text-align: center;
}
.unlock-first-section-top-mobile {
  padding-top: 300px;
}
.unlock-first-section-top {
  padding-top: 20%;
}
.unlock-page-header {
  height: 100vh;
  background-position: center center;
  background-size: cover;
  margin: 0;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
input {
  text-indent: 10px;
  border: 1px solid rgb(255, 255, 255, 0.5);
  height: 48px !important;
  font-size: 18px !important;
  -webkit-text-fill-color: white !important;
  appearance: none;
  background-color: rgba(0, 0, 0, 0.6);
}
input:focus {
  border: 1px solid rgb(255, 255, 255, 0.7);
  background-color: rgba(0, 0, 0, 0.8);
  caret-color: white;
}
::placeholder {
  color: #ffffff;
  opacity: 0.4;
}
input:focus::placeholder {
  color: transparent;
  border: 1px solid rgb(255, 255, 255, 1);
}
.arrow {
  float: right;
  margin-right: 12px;
  margin-top: -36px;
  width: 24px;
  height: 24px;
  position: relative;
  z-index: 2;
  color: white;
  cursor: pointer;
}
.black {
  background-color: black;
}
</style>
